import { RdcConsignmentsApiService } from 'core/api';
import { IRdcConsignmentDao } from 'core/api/types/rdc.interface';
import { useDocument } from 'core/hooks/useDocument';
import { useParams } from 'react-router-dom';
import PageHeader from 'shared/components/page-header/page-header';
import PageHeaderSkeleton from 'shared/components/page-header/page-header-skeleton';
import RdcOverviewDetails from './rdc-overview-details/rdc-overview-details';
import { useState } from 'react';
import RdcOverviewPhotos from './rdc-overview-photos/rdc-overview-photos';
import RdcOverviewSignatures from './rdc-overview-signatures/rdc-overview-signatures';
import SharedTabButton from 'shared/components/buttons/tab-button/tab-button';

const RdcOverview = () => {
  const { uid } = useParams();
  const { data, loading } = useDocument<IRdcConsignmentDao>({
    apiService: RdcConsignmentsApiService,
    uid,
  });
  const [selectedTab, setSelectedTab] = useState<string>('photos');

  const tabs = [
    { label: 'Photos', key: 'photos' },
    { label: 'Signatures', key: 'signatures' },
  ];

  const getTabContent = (consignment: IRdcConsignmentDao) => {
    switch (selectedTab) {
      case 'photos':
        return <RdcOverviewPhotos consignment={consignment} />;
      case 'signatures':
        return <RdcOverviewSignatures consignment={consignment} />;
    }
  };

  return (
    <>
      {!data || loading ? (
        <PageHeaderSkeleton actions={[]} subtitle={true} />
      ) : (
        <>
          <PageHeader title='RDC Consignment' showBack={true} />
          <div className='flex flex-row py-6'>
            <RdcOverviewDetails consignment={data} />
            <div className='pl-6 w-full'>
              <div className='relative'>
                <div className='flex relative z-10'>
                  {tabs.map((tab) => (
                    <SharedTabButton key={tab.key} changeTab={setSelectedTab} tab={tab} currentTab={selectedTab} />
                  ))}
                </div>
                <div className='absolute bottom-0 left-0 right-0 h-px bg-gray-200' />
              </div>
              <div className='mt-6'>{getTabContent(data)}</div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default RdcOverview;
